import { InjectionToken } from '@angular/core';
import { HttpContextToken } from '@angular/common/http';

export const TIMEOUT_COUNT = new HttpContextToken(() => 30000);
export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
